!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.mainDetails = this.querySelector("details"), this.mainDetails.addEventListener("toggle", this.onToggle.bind(this));
    }
    onToggle() {
      if (!this.mainDetails.open) return;
      this.closeTeleportDetails();
      const e = this.querySelector('[name="mobileNavLevel1"]');
      e && !e.hasAttribute("open") && e.setAttribute("open", "");
    }
    closeTeleportDetails() {
      document.querySelectorAll("teleport-details").forEach(e => {
        e.close && "function" == typeof e.close && e.close();
      });
    }
  }
  customElements.define("mobile-nav", e);
}();